import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  spacing
} from '../../../theme';

export const StyledSkillsNoStack = styled.div`
  max-width: ${container('xs')};
  margin: auto;
  padding: ${spacing('lg')};
  background-color: ${color('emerald_100')};
  border-radius: ${radius('md')};
  display: flex;
  text-align: left;
`;

export const StyledSkillsNoStackImg = styled.img`
  display: block;
  width: ${spacing('xl4')};
  height: ${spacing('xl4')};
  margin-right: ${spacing('md')};
`;

export const StyledSkillsNoStackContent = styled.div`
  font-size: ${fontSize('sm')};
  color: ${color('text_subtle')};

  p {
    margin: 0;
  }
`;

export const StyledSkillsNoStackTitle = styled.h5`
  font-size: ${fontSize('md')};
  line-height: 1.25;
  color: ${color('text_default')};
  font-weight: ${fontWeight('black')};
  margin-top: 0;
  margin-bottom: ${spacing('xs2')};
`;
